//node-modules
import { ReactSVG } from "react-svg";

interface Props {
  imagePath: string;
  color?: string;
  width?: number;
  height?: number;
}

const Icon = ({ imagePath, width, height, color }: Props) => {
  return (
    <ReactSVG
      src={imagePath}
      className="svg"
      beforeInjection={(svg) => {
        svg.setAttribute(
          "style",
          `fill: ${color}; width: ${width}; height: ${height};`
        );
      }}
    />
  );
};

export default Icon;
